import { Injectable, signal, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, interval, Subscription, catchError, of } from 'rxjs';
import { Banner } from '../models/banner';
import { prodAPI } from '../../../env';

@Injectable({
  providedIn: 'root'
})
export class BannersService implements OnDestroy {
  private apiUrl = `${prodAPI}/api/overlay/banners`;
  private bannersSignal = signal<Banner[]>([]);
  private activeBannersSignal = signal<Banner[]>([]);
  private pollingSubscription?: Subscription;
  private readonly POLLING_INTERVAL = 3600000; 

  constructor(private http: HttpClient) {
    this.startPolling();
  }

  ngOnDestroy(): void {
    this.stopPolling();
  }

  
  getBanners() {
    return this.bannersSignal.asReadonly();
  }

  
  fetchBanners(): Observable<Banner[]> {
    return this.http.get<Banner[]>(this.apiUrl).pipe(
      catchError(err => {
        console.error('API request failed:', err);
       
        return of([]);
        return of([]);
      })
    );
  }

  
  loadBanners(): void {
    this.fetchBanners().subscribe({
      next: (banners) => {
       
        const realBanners = banners || [];
        const combinedBanners = [...realBanners];
        
        console.log('Real banners from API:', realBanners);
        console.log('Combined banners:', combinedBanners);
        
        this.bannersSignal.set(combinedBanners);
        this.activeBannersSignal.set(combinedBanners);
      },
      error: (err) => {
        console.error('Failed to load banners:', err);
        
      }
    });
  }

  
  private startPolling(): void {
    this.loadBanners();
    
    
    this.pollingSubscription = interval(this.POLLING_INTERVAL).subscribe(() => {
      this.loadBanners();
    });
  }

  
  private stopPolling(): void {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  
  refreshBanners(): void {
    this.loadBanners();
  }

}
